import React, { useEffect, useState } from 'react'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import {
    InstancesCatalogDropdownSelectOption,
    InstancesCatalogDropdownSelectProps,
} from './InstancesCatalogDropdownSelect-types'

export const InstancesCatalogDropdownSelect = ({
    value,
    options,
    onChange,
    callbackValue,
}: InstancesCatalogDropdownSelectProps) => {
    const [selectedValue, setSelectedValue] = useState(value)

    useEffect(() => {
        if (!value) return

        if (callbackValue) {
            callbackValue(value)
        }
    }, [])

    return (
        <Dropdown
            value={selectedValue}
            options={options}
            onChange={(selected: InstancesCatalogDropdownSelectOption) => {
                setSelectedValue(String(selected.id))
                onChange(selected)
            }}
            indentSize={'mini'}
        />
    )
}
